import React from 'react';
import { FunctionComponent } from 'react';
import { AppInsightsProvider } from './AppInsightsProvider';
import { CustomErrorBoundary } from './CustomErrorBoundary';

export type ErrorBoundaryProps = {
  errorText?: string;
  children: React.ReactElement;
};

export const ErrorBoundary: FunctionComponent<ErrorBoundaryProps> = ({
  errorText,
  children,
}) => (
  <AppInsightsProvider>
    <CustomErrorBoundary errorText={errorText}>{children}</CustomErrorBoundary>
  </AppInsightsProvider>
);
